module.exports = __webpack_public_path__ + "static/media/times-hexagon.b3878433.svg";